// TODO: Add more constants from various places

export const NO_DOCUMENTS_MESSAGE = 'No documents available';
export const SORT_SELECTOR_PLACEHOLDER = 'Sort options';
export const EXPANDED_PARAM = 'expanded';
export const EXPAND_ALL_PARAM = 'expand_all';
export const DISALLOWED_FILTER_PARAMS = [EXPANDED_PARAM, EXPAND_ALL_PARAM]; // Query string params that should not be handled as a filter
export const FILTER_SEARCH_KEYS = {
    DOCUMENT_META: 'documentFilterSearch',
    DOCUMENT_PROPERTY: 'documentPropertySearch',
    CLSS: 'filterSearch',
};
export const SORT_DIRECTIONS = {
    ASC: 'ASC',
    DESC: 'DESC',
};
export const ADVANCED_SORT_TYPES = {
    allocations: 'Allocations',
    statistics: 'Statistics',
};
export const OPERATORS = {
    EQUAL: '=',
    NOT_EQUAL: '!=',
    GREATER_THAN: '>',
    GREATER_THAN_OR_EQUAL: '>=',
    LESS_THAN: '<',
    LESS_THAN_OR_EQUAL: '<=',
};
export const DATE_DIFFS = {
    DAYS: 'DAYS',
    WEEKS: 'WEEKS',
    MONTHS: 'MONTHS',
    YEARS: 'YEARS',
};



// WEBPACK FOOTER //
// ./src/constants.ts